// extracted by mini-css-extract-plugin
module.exports = {"userSelect_none":"_9e1425b4d3--userSelect_none--YJE8Q","userSelect_auto":"_9e1425b4d3--userSelect_auto--WYbE7","userSelect_all":"_9e1425b4d3--userSelect_all--JAOsx"};